import { useEffect, useState } from 'react'
import { ArrowUp } from 'lucide-react'
import { useTranslation } from 'react-i18next'

const SHOW_AFTER_PX = 400

/**
 * Desktop-only floating button that scrolls the document back to the top.
 * Hidden on mobile/tablet (`hidden lg:flex`) since those layouts are short
 * enough, and only visible once the visitor has scrolled past
 * `SHOW_AFTER_PX`.
 */
export function ScrollToTopButton() {
  const { t } = useTranslation()
  const [isVisible, setIsVisible] = useState(false)

  useEffect(() => {
    const handleScroll = () => setIsVisible(window.scrollY > SHOW_AFTER_PX)
    handleScroll()
    window.addEventListener('scroll', handleScroll, { passive: true })
    return () => window.removeEventListener('scroll', handleScroll)
  }, [])

  if (!isVisible) return null

  return (
    <button
      type="button"
      onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
      aria-label={t('common.back_to_top')}
      title={t('common.back_to_top')}
      className="hidden lg:flex fixed bottom-8 right-8 z-40 h-11 w-11 items-center justify-center rounded-full bg-primary text-primary-foreground shadow-lg transition-opacity hover:opacity-90 print:hidden"
    >
      <ArrowUp className="h-5 w-5" />
    </button>
  )
}
